import React, { useCallback, useEffect, useState } from 'react';
import Content from "../../globalComponent/Content";
import { Calendar, momentLocalizer } from 'react-big-calendar';
import { Button, FormControl } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import moment from "moment";
import '../../styles/mobilnosc.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import "moment/locale/pl";
import {
    delEventNew,
    dodajDyspozycyjnoscWG,
    getKalendarzWG,
    getNumer,
    scrollToTop
} from "../../utilities/Serwis";
import { Modal, message, Row, Col } from "antd";
import { InfoCircleOutlined, UserOutlined } from "@ant-design/icons";

const localizer = momentLocalizer(moment);

const translation = {
    date: 'Data',
    time: 'Czas',
    event: 'Wydarzenie',
    allDay: 'Cały dzień',
    week: 'tydzień',
    work_week: 'tydzień roboczy',
    day: 'dzień',
    month: 'miesiąc',
    previous: 'poprzedni',
    next: 'następny',
    yesterday: 'wczoraj',
    tomorrow: 'jutro',
    today: 'dziś',
    agenda: 'lista',
};

const DyzuryMain = () => {
    const [dyspozycje, setDyspozycje] = useState<any[]>([]);
    const [dyspozycja, setDyspozycja] = useState<string | null>(null);
    const [czasStart, setCzasStart] = useState('06:00');
    const [czasKoniec, setCzasKoniec] = useState('18:00');
    const [scrollDate, setScrollDate] = useState(moment().format("YYYY-MM-DD"));
    const [view, setView]: any = useState<'month' | 'day' | 'agenda'>('month');
    const [showFormularz, setShowFormularz] = useState(false);

    const today = new Date();
    const numerUzytkownika = getNumer();

    useEffect(() => {
        scrollToTop();
        pobierzEventy();
    }, []);

    const pobierzEventy = useCallback(() => {
        getKalendarzWG()
            .then((response) => {
                setDyspozycje(przeksztalcResponseDoKalendarza(response.data));
            })
            .catch((e) => {
                console.error('Błąd pobierania kalendarza', e);
            });
    }, []);

    const przeksztalcResponseDoKalendarza = (response: any[]): any[] => {
        return response.map((item: any) => ({
            id: item.ID,
            numer: item.numer,
            title: `${item.IMIE} ${item.NAZWISKO}`,
            imie: item.IMIE,
            nazwisko: item.NAZWISKO,
            start: new Date(item.dataStart),
            end: new Date(item.dataKoniec),
            c: item.PRAW_C,
        }));
    };

    const changeNavigate = (date: Date) => {
        setScrollDate(moment(date).format("YYYY-MM-DD"));
    };

    const handleSelectEvent = (event: any) => {
        setScrollDate(moment(event.start).format("YYYY-MM-DD"));
        setView('day');
    };

    const ileOsob = (data: Date) => {
        const dayStr = moment(data).format("YYYY-MM-DD");
        const eventsThatDay = dyspozycje.filter(e => moment(e.start).format("YYYY-MM-DD") === dayStr);
        const uniqueNums = new Set(eventsThatDay.map(e => e.numer));
        return uniqueNums.size;
    };

    const handleSelectSlot = (slot: any) => {
        const selectedDate = moment(slot.start);
        if (selectedDate.isBefore(moment(), 'day')) {
            message.warning('Nie można wybrać przeszłej daty.');
            return;
        }

        setDyspozycja(selectedDate.format('YYYY-MM-DD'));
        setCzasStart(selectedDate.format('HH:mm'));
        setCzasKoniec(moment(slot.end).format('HH:mm') === '00:00' ? '23:59' : moment(slot.end).format('HH:mm'));
        setShowFormularz(true);
    };

    const validateTimeOrder = (start: string, end: string): boolean => {
        return moment(start, 'HH:mm').isBefore(moment(end, 'HH:mm')) || start === end;
    };

    const onClickZapisz = (start = czasStart, koniec = czasKoniec) => {
        if (!validateTimeOrder(start, koniec)) {
            message.error("Godzina końcowa musi być późniejsza niż początkowa!");
            return;
        }

        const dataStr = dyspozycja!;
        const czas_start = new Date(`${dataStr} ${start}:00`);
        const czas_end = new Date(`${dataStr} ${koniec}:00`);

        // Korekta strefy czasowej (jeśli potrzebna)
        const offset = czas_start.getTimezoneOffset();
        if (offset !== 0) {
            czas_start.setHours(czas_start.getHours() - offset / 60);
            czas_end.setHours(czas_end.getHours() - offset / 60);
        }

        dodajDyspozycyjnoscWG(czas_start, czas_end)
            .then(() => {
                setShowFormularz(false);
                pobierzEventy();
                message.success('Dodano dyspozycyjność');
            })
            .catch((e) => {
                message.error(e.response?.data || 'Błąd podczas zapisywania');
                setShowFormularz(false);
            });
    };

    const eventStyleGetter = (event: any) => {
        let backgroundColor = '';

        if (event.numer === numerUzytkownika) {
            backgroundColor = '#d97b02'; // Ja
        } else if (event.c === '1') {
            backgroundColor = '#5e5e5e'; // Kierowca C
        }

        return { style: { backgroundColor } };
    };

    const usunDyspozycje = (id: any) => {
        delEventNew(id).then((response) => {
            pobierzEventy();
            message.success('Usunięto dyspozycyjność');
            // setDyspozycja(null);
        }).catch((e) => {
            message.error(e.response.data);
        })
    }

    const onAnuluj = () => {
        setShowFormularz(false);
        setDyspozycja(null);
        setCzasStart('06:00');
        setCzasKoniec('18:00');
    };

    // Kluczowa część: własne dyspozycje w wybranym dniu
    const wlasneDyspozycjeWDniu = dyspozycja
        ? dyspozycje.filter(
            (e) =>
                moment(e.start).format("YYYY-MM-DD") === dyspozycja &&
                e.numer === numerUzytkownika
        )
        : [];

    const maJakiesDyspozycjeWDniu = wlasneDyspozycjeWDniu.length > 0;

    return (
        <Content>
            <div className={'mobilnoscMain'}>
                <Calendar
                    style={{ minHeight: '500px' }}
                    className={'kalendarzMobilnosci'}
                    culture='pl'
                    messages={translation}
                    selectable
                    events={dyspozycje}
                    view={view}
                    onView={setView}
                    views={['month', 'day', 'agenda']}
                    step={30}
                    timeslots={2}
                    date={scrollDate}
                    onNavigate={changeNavigate}
                    popup
                    min={new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0)}
                    onSelectEvent={handleSelectEvent}
                    onSelectSlot={handleSelectSlot}
                    eventPropGetter={eventStyleGetter}
                    components={{
                        month: {
                            dateHeader: ({ date, label }) => (
                                <div className={'dzienHeader'}>
                                    {moment(date).isSameOrAfter(moment(), 'day') ? (
                                        <div
                                            className={'dzienIleOsob'}
                                            style={{ color: ileOsob(date) === 0 ? 'red' : 'unset' }}
                                        >
                                            <UserOutlined /> {ileOsob(date)}
                                        </div>
                                    ) : <div></div>}
                                    {label}
                                </div>
                            ),
                        },
                    }}
                    localizer={localizer}
                />

                <div className={'legenda'}>
                    <p style={{ fontSize: 'small', color: 'rgb(148,148,148)' }}>
                        <InfoCircleOutlined /> W ciągu dnia można zapisać się kilka razy, wybierając odpowiednie dla siebie godziny.
                    </p>
                    <div className={'kolor'}>
                        <div className={'kd kolorJ'} /><label>Ja</label>
                    </div>
                    <div className={'kolor'}>
                        <div className={'kd kolorR'} /><label>Ratownik</label>
                    </div>
                    <div className={'kolor'}>
                        <div className={'kd kolorC'} /><label>Kierowca C</label>
                    </div>
                </div>

                <h3 style={{ marginTop: '35px', textAlign: 'center' }}>Skład na dziś</h3>
                <Calendar
                    style={{ minHeight: '500px' }}
                    className={'dzisTimeline'}
                    culture='pl'
                    formats={{ dayHeaderFormat: (date) => moment(date).format('dddd, D MMMM YYYY') }}
                    messages={translation}
                    events={dyspozycje}
                    view={'day'}
                    step={30}
                    timeslots={4}
                    date={today}
                    min={new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0)}
                    eventPropGetter={eventStyleGetter}
                    localizer={localizer}
                />

                <Modal
                    title="Dodaj dyspozycję"
                    open={showFormularz}
                    onCancel={onAnuluj}
                    footer={null}
                >
                    <Row>
                        <Col span={24}>
                            <h5 style={{ textAlign: 'center', padding: '15px' }}>
                                {dyspozycja && moment(dyspozycja).format('D MMMM YYYY (dddd)')}
                            </h5>
                        </Col>
                    </Row>

                    <Row className={'mb-4'}>
                        <Col span={12} style={{ textAlign: 'center' }}>
                            <label>Start</label>
                            <FormControl
                                type="time"
                                value={czasStart}
                                onChange={(e: any) => setCzasStart(e.target.value)}
                                style={{ width: 'unset', margin: 'auto' }}
                            />
                        </Col>
                        <Col span={12} style={{ textAlign: 'center' }}>
                            <label>Koniec</label>
                            <FormControl
                                type="time"
                                value={czasKoniec}
                                onChange={(e: any) => {
                                    if (e.target.value === "00:00") {
                                        message.error("Godzina 00:00 jest niedozwolona!");
                                        return;
                                    }
                                    setCzasKoniec(e.target.value);
                                }}
                                style={{ width: 'unset', margin: 'auto' }}
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col>Lub wybierz jedną z opcji</Col>
                    </Row>

                    <Row>
                        <Col>
                            <div className={'btnCzasWybor'}>
                                <Button
                                    variant={'warning'}
                                    size={'sm'}
                                    onClick={() => onClickZapisz('08:00', '16:00')}
                                >
                                    <>8:00 - 16:00</><p>DZIEŃ</p>
                                </Button>
                                <Button
                                    variant={'primary'}
                                    size={'sm'}
                                    onClick={() => onClickZapisz('16:00', '23:59')}
                                >
                                    <>16:00 - 23:59</><p>NOC</p>
                                </Button>
                                <Button
                                    variant={'success'}
                                    size={'sm'}
                                    onClick={() => onClickZapisz('00:00', '23:59')}
                                >
                                    <>00:00 - 23:59</><p>24h</p>
                                </Button>
                            </div>
                        </Col>
                    </Row>

                    <Row style={{ marginTop: '15px', marginBottom: '15px' }}>
                        <Col style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginInline: '3px' }}>
                            <Button variant={'danger'} size={'sm'} onClick={onAnuluj}>Anuluj</Button>
                            <Button variant={'success'} size={'sm'} onClick={() => onClickZapisz()}>Dodaj</Button>
                        </Col>
                    </Row>

                    {/* Sekcja z pozycjami do usunięcia – tylko jeśli są własne dyspozycje */}
                    {maJakiesDyspozycjeWDniu && (
                        <Row>
                            <Col style={{width: '100%'}}>
                                <div className={'pozycjaUsunMain'}>
                                    <h6>Pozycje zapisane w tym dniu:</h6>
                                    {wlasneDyspozycjeWDniu.map((item: any) => (
                                        <div key={item.id} className={'pozycjaUsun'}>
                                            <div>{item.imie} {item.nazwisko}</div>
                                            <div>{moment(item.start).format("HH:mm")} - {moment(item.end).format("HH:mm")}</div>
                                            <button type="button" className="btn btn-danger btnUsun" onClick={() => usunDyspozycje(item.id)}>
                                                Usuń
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </Col>
                        </Row>
                    )}
                </Modal>
            </div>
        </Content>
    );
};

export default DyzuryMain;